import React from "react"
import Svg from "../../_svgs/svg"
import { accessibilityEnterCheck } from "../../../helpers/accessibilityHelper"

export default function Categories({ categories, toggleCategory, merchants, numFound, selectedCategories, searchQuery, windowWidth, merchantType }) {
  if (!categories) return ""
  let mobileShowCategoryCheck = windowWidth >= 950 || searchQuery.length === 0

  return (
    <div className="checkmarktags">
      {categories.length > 0 &&
        mobileShowCategoryCheck &&
        categories.map((category, index) => {
          let disable = merchants.some((m) => m.categories?.includes(category)) ? false : true
          // disable = numFound == 0 && !selectedCategories.includes(category)
          return (
            <span key={`${merchantType}_${category}`}>
              <input
                id={category}
                disabled={disable}
                checked={selectedCategories.includes(category)}
                type="checkbox"
                onChange={() => toggleCategory(category)}
              />
              <label
                htmlFor={category}
                tabIndex={disable ? -1 : 0}
                onKeyDown={(e) => accessibilityEnterCheck(e, () => toggleCategory(category))}
                aria-describedby="search-results"
              >
                <Svg iconName={"tagcheck"} />
                {category}
              </label>
            </span>
          )
        })}
    </div>
  )
}
